import { ref } from 'vue'
import axios from 'axios'

// Statut considéré comme « en cours » côté backend (projects.status)
export const IN_PROGRESS_STATUS = 'in_progress'

export const PROJECT_STATUS_META = {
    planned: { label: 'Planifié', color: '#2563eb', bg: '#eff6ff', border: '#bfdbfe', icon: 'bi-calendar-event' },
    in_progress: { label: 'En cours', color: '#047857', bg: '#ecfdf5', border: '#a7f3d0', icon: 'bi-play-circle-fill' },
    on_hold: { label: 'En pause', color: '#b45309', bg: '#fffbeb', border: '#fde68a', icon: 'bi-pause-circle-fill' },
    completed: { label: 'Terminé', color: '#475569', bg: '#f1f5f9', border: '#cbd5e1', icon: 'bi-check-circle-fill' },
    cancelled: { label: 'Annulé', color: '#b91c1c', bg: '#fef2f2', border: '#fecaca', icon: 'bi-x-circle-fill' }
}

// État global partagé entre tous les sélecteurs de projet
const inProgressOnly = ref(false)
let loadPromise = null

/**
 * Paramètre global « n'afficher que les projets en cours dans les sélecteurs ».
 */
export function useProjectSelectorSettings() {
    const loadProjectSelectorSettings = () => {
        if (loadPromise) return loadPromise

        loadPromise = axios.get('/api/general-settings')
            .then(response => {
                if (response.data?.success) {
                    inProgressOnly.value = !!response.data.data?.project_selectors_in_progress_only
                }
            })
            .catch(() => {
                // Nouvel essai possible plus tard (ex: après connexion)
                loadPromise = null
            })

        return loadPromise
    }

    const setInProgressOnly = (value) => {
        inProgressOnly.value = !!value
    }

    /**
     * Applique le filtre « en cours » à une liste de projets.
     * Les projets dont l'id figure dans keepIds restent toujours visibles
     * (ex: projet déjà sélectionné sur un enregistrement existant).
     */
    const filterSelectableProjects = (projects, keepIds = []) => {
        const list = Array.isArray(projects) ? projects : []
        if (!inProgressOnly.value) return list

        const keep = new Set(keepIds.filter(id => id !== null && id !== undefined && id !== '').map(String))
        return list.filter(p => {
            if (!p || typeof p !== 'object') return true
            // Pas d'information de statut : on ne masque pas
            if (p.status === undefined || p.status === null) return true
            return p.status === IN_PROGRESS_STATUS || keep.has(String(p.id))
        })
    }

    return {
        inProgressOnly,
        loadProjectSelectorSettings,
        setInProgressOnly,
        filterSelectableProjects
    }
}
